import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { LinkComponent } from '@valk-nx/components/ui-link/src/lib/link';
import { Link } from '@valk-nx/components/ui-link/src/lib/link.interface';
import { LANGUAGE, Language } from '@valk-nx/core/lib/core';
import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';
import { WhatsappPipe } from '@valk-nx/core/lib/pipes/whatsapp/whatsapp.pipe';

import {
	FooterInformation,
	FooterMenu,
	FooterMenuLink,
	FooterUSP,
} from './footer.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-footer',
	templateUrl: './footer.html',
	imports: [
		CommonModule,
		LinkComponent,
		AngularSvgIconModule,
		WhatsappPipe,
		RouterModule,
		TranslatePipe,
	],
})
export class FooterComponent extends BaseDirective {
	private readonly rootLanguage = inject<Language>(LANGUAGE);

	bottomItems = input<FooterMenuLink[] | undefined>(undefined);
	information = input<FooterInformation | undefined>(undefined);
	isMinimal = input<boolean>(false);
	title = input<string>('');
	menu = input<FooterMenu>({
		items: [
			{
				title: '',
				items: [
					{
						title: '',
						url: '',
					},
				],
			},
		],
	});
	usps = input<FooterUSP[]>([
		{
			icon: 'assets/icons/logo-valk-white.svg',
			text: '',
			url: '',
		},
		{
			icon: 'assets/icons/logo-valk-white.svg',
			text: 'Valk verrast',
			url: '',
		},
	]);

	socials = input<{
		facebook?: string;
		instagram?: string;
		tiktok?: string;
		youtube?: string;
		linkedin?: string;
		pinterest?: string;
		whatsapp?: string;
	} | null>({
		facebook: 'https://www.facebook.com/VanderValkVerrast',
		instagram: 'https://www.instagram.com/valkverrast',
		tiktok: undefined,
		youtube: undefined,
		linkedin: undefined,
		pinterest: undefined,
		whatsapp: undefined,
	});

	toTop = output<void>();

	transformedTitle = computed(() =>
		this.title().toLowerCase().trim().replace(/\s+/g, '-'),
	);

	logoLink = computed<Link | undefined>(() => ({
		url: this.language === this.rootLanguage ? '/' : `/${this.language}`,
		title: 'home',
	}));

	constructor() {
		super();
	}

	scrollToTop(): void {
		this.toTop.emit();
		window.scrollTo({
			behavior: 'smooth',
			left: 0,
			top: 0,
		});
	}
}
